import { render } from "./ModalElectionPrivacy.vue?vue&type=template&id=a66c4326&scoped=true"
import script from "./ModalElectionPrivacy.vue?vue&type=script&lang=js"
export * from "./ModalElectionPrivacy.vue?vue&type=script&lang=js"

import "./ModalElectionPrivacy.vue?vue&type=style&index=0&id=a66c4326&scoped=true&lang=css"

import exportComponent from "/Users/geoffsargison/Documents/laravel-valet/ces-calculator/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a66c4326"]])

export default __exports__